/**
 * SwitcherContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled switcher container.
 */
const SwitcherContainer = styled.div<React.CSSProperties>`
  width: ${186 * Screen.widthRatio}px;
  height: ${75 * Screen.widthRatio}px;
  border-radius: ${55 * Screen.widthRatio}px;
  border-style: solid;
  border-width: ${2 * Screen.widthRatio}px;
  border-color: white;
  cursor: pointer;
`;

export default SwitcherContainer;
